<template>
  <div class="publishers-tab">
    <artmisads-table
      :columns="columns"
      :data-source="tableData"
      v-model:pagination="pagination"
       :change="onTableChange"
      :scroll="{ x: 980 }"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'publisher'">
          <div class="product-cell">
            <div >
              <LogoImage :logoUrl="record.publisherAvatarUrl" :brandName="record.publisherName" />
            </div>
            <div>
              <div class="product-link1">
                  {{ record.publisherName }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="column.key === 'clicks'">
            <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
                {{ record.attributionClicks||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
                {{ record.associateClicks||0 }}
              </div>
            </div>
          </div>
          </template>
          <template v-if="column.key === 'sales'">
            <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.attributionSalesAmount||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.associateSalesAmount||0 }}
              </div>
            </div>
          </div>
          </template>
        <template v-if="column.key === 'products'">
          <a href="javascript:void(0)" class="product-count" @click="openDetails(record)">
            {{ record.productCount }}
          </a>
        </template>
      </template>
    </artmisads-table>

    <PublisherDetailsModal ref="publisherDetailsModalRef" />
  </div>
</template>

<script setup>
import { computed, ref, reactive, onMounted } from "vue"
import { useI18n } from "vue-i18n"
import PublisherDetailsModal from "./PublisherDetailsModal.vue"
import LogoImage from "@/components/LogoImage.vue"
import { sellerCpcApi } from "~/server"
import { CURRENCY_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"

const { t } = useI18n()
const user = useUserInfoStore()
const currency = CURRENCY_MAPPER[user.userInfo?.countryCode]?.currency || '$'
const columns = computed(() => [
  { title: t("seller.cpcPublishersTab.colPublisher"), dataIndex: "publisherName", key: "publisher", width: 220 },
  { title: t("seller.cpcPublishersTab.colBudgetEarned"), dataIndex: "budgetEarned", key: "budgetEarned", width: 170 },
  { title: t("seller.cpcPublishersTab.colClicks"), key: "clicks", width: 220 },
  { title: t("seller.cpcPublishersTab.colSales"), key: "sales", width: 220 },
  { title: t("seller.cpcPublishersTab.colProducts"), dataIndex: "products", key: "products", width: 120 },
])
const props = defineProps({
  id: {
    type: String||Number,
    required: true,
  },
})
const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ["10", "20", "30", "40", "50"],
})
const onTableChange = ({ current, pageSize }) => {

pagination.current = current
pagination.size = pageSize
pagination.pageSize = pageSize
getCpcCampaignsPublishers()
}

const tableData = ref([
  
])
const getCpcCampaignsPublishers = () => {
  sellerCpcApi.getCpcCampaignsPublishers({ campaignId: props.id, page: pagination.current, size: pagination.size }).then(res => {
    tableData.value = res.data.data
    pagination.total = res.data.total
  })
}
const publisherDetailsModalRef = ref(null)
// getCpcCampaignsPublishers()
onMounted(()=>{
  getCpcCampaignsPublishers()
})
const openDetails = (record) => {
  publisherDetailsModalRef.value?.openModal( {
    ...record,
    campaignId:props.id
   } )
}
</script>

<style scoped lang="less">
.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.product-link {
  color: #4b5563;
  text-decoration: underline;
  line-height: 1.3;
  display: block;
  width: 780px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.publishers-tab {
  padding-top: 4px;
}

.publisher-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.publisher-name {
  color: #374151;
  font-weight: 600;
}

.metric-cell {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .item-row {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #f1f0f5;
    min-width: 111px;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
.num {
  margin-left: 8px;
  color: #111827;
}

.dot {
  margin-right: 6px;
}

.num {
  margin-left: 8px;
  color: #111827;
}

.product-count {
  color: #7d64ff;
  text-decoration: underline;
}
</style>
